__turbopack_context__.v({
  "scrollable": "FullShareView-module__Z7IArq__scrollable",
});
